import { formatDistanceToNow } from "date-fns";

import { I18nService } from "@bitwarden/common/abstractions/i18n.service";

// "just now" within the first minute (date-fns would say "less than a minute ago", the design
// calls for "just now"), then e.g. "3 days ago". Empty when there's no usable date, so callers
// can drop the segment.
export function formatRelativeTime(
  date: Date | null | undefined,
  i18nService: I18nService,
): string {
  if (date == null || isNaN(date.getTime())) {
    return "";
  }
  if (Date.now() - date.getTime() < 60_000) {
    return i18nService.t("justNow");
  }
  return formatDistanceToNow(date, { addSuffix: true });
}
